<template>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>
  <div class="page-wrapper" v-if="Object.keys(caseData).length">
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <div class="contact-head">
            <div class="row align-items-center">
              <div class="col-sm-6">
                <ul class="contact-breadcrumb">
                  <li v-if="user?.roles[0] === 'super_admin'">
                    <router-link :to="{ path: '/crm/support-list' }">
                      <i class="ti ti-arrow-narrow-left"></i>
                      Support Tickets
                    </router-link>
                  </li>
                  <li v-else="user?.roles[0] !== 'super_admin'">
                    <router-link :to="{ path: '/crm/support-case-list' }">
                      <i class="ti ti-arrow-narrow-left"></i>
                      Support Tickets
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class=" mt-4">
            <!-- Ticket Info Card -->
            <div class="row">
              <div class="col-xl-12 col-lg-12">
                <div class="card">
                  <div class="card-body settings-form">
                    <Form @submit="updateCase" :validation-schema="schema">
                      <div class="row align-items-center mb-3">
                        <div class="col-6">
                          <h4>Edit Ticket</h4>
                        </div>
                        <div class="submit-button text-end col-6">
                          <button type="button" class="btn btn-light" @click="handleCancel">
                            Back
                          </button>
                          <button type="submit" class="btn btn-primary">Update</button>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-wrap">
                            <label class="col-form-label">Title <span class="text-danger">*</span></label>
                            <div class="">
                              <Field name="subject" type="text" class="form-control" placeholder=""
                                :class="{ 'readonly-field': user?.roles[0] === 'super_admin' }"
                                :readonly="user?.roles[0] === 'super_admin'" v-model="form.subject" />
                            </div>
                            <ErrorMessage name="subject" class="text-danger" />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-wrap">
                            <label class="col-form-label">Status</label>
                            <Field as="select" name="C" class="form-select" v-model="form.status">
                              <option value=""> ----select---- </option>
                              <option v-for="res in Options.status" :key="res.value" :value="res.value">
                                {{ res.text }}
                              </option>
                            </Field>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-wrap">
                            <label class="col-form-label">Priority</label>
                            <!-- :disabled="user?.roles[0] === 'super_admin'" :class="{ 'readonly-field': user?.roles[0] === 'super_admin' }" -->
                            <Field as="select" name="priority" class="form-select" v-model="form.priority">
                              <option value="">
                                ----select----
                              </option>
                              <option v-for="res in Options.priority" :key="res.value" :value="res.value">
                                {{ res.text }}
                              </option>
                            </Field>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-wrap">
                            <!-- :class="{ 'readonly-field': user?.roles[0] === 'super_admin' }" :disabled="user?.roles[0] === 'super_admin'" -->
                            <label class="col-form-label">Type</label>
                            <Field as="select" name="type" class="form-select" v-model="form.type">
                              <option value="">
                                ----select----
                              </option>
                              <option v-for="res in Options.type" :key="res.value" :value="res.value">
                                {{ res.text }}
                              </option>
                            </Field>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-wrap">
                            <label class="col-form-label">Description</label>
                            <textarea class="form-control" rows="4" v-model="form.description"
                              :class="{ 'readonly-field': user?.roles[0] === 'super_admin' }"
                              :readonly="user?.roles[0] === 'super_admin'"></textarea>
                          </div>
                        </div>

                        <div class="col-md-12">
                          <div class="form-wrap">
                            <div><label class="col-form-label">Attachments</label></div>

                            <!-- Upload Icon -->
                            <div class="upload-icon">
                              <button type="button" class="btn d-flex align-items-center gap-2"
                                :disabled="user?.roles[0] === 'super_admin'" @click="triggerFileInputCase"
                                style="background-color: #f1f1f1; color: #6c757d; border: none; padding: 6px 12px; border-radius: 6px;">
                                <i class="ti ti-paperclip" style="font-size: 18px;"></i>
                                <!-- Attachments -->
                              </button>
                            </div>

                            <!-- Hidden File Input -->
                            <input type="file" ref="fileInputCase" @change="handleFileUploadCase" multiple
                              style="display: none;" />

                            <div class="file-container">
                              <div v-for="(file, index) in previewImages" :key="index" class="attachment-preview-reply">
                                <!-- 📷 Image Preview -->
                                <div v-if="isImage(file?.file?.name || file.file_url)" class="file-placeholder-case ">
                                  <a :href="file.file_url" target="_blank">
                                    <img :src="file.file_url" alt="Image Preview" style="cursor: pointer;" />
                                  </a>
                                </div>

                                <!-- 📄 PDF Preview -->
                                <!-- <div v-else-if="isPDF(file.file.name)">
                              <iframe :src="file.file_url" type="application/pdf" width="100%" height="300"></iframe>
                            </div> -->

                                <!-- 🎧 Audio Preview -->
                                <div v-else-if="isAudio(file?.file?.name || file.file_url)"
                                  class="file-placeholder-case ">
                                  <audio controls :src="file.file_url"></audio>
                                </div>

                                <!-- 🎞 Video Preview -->
                                <div v-else-if="isVideo(file?.file?.name || file.file_url)"
                                  class="file-placeholder-case ">
                                  <video controls width="100%">
                                    <source :src="file.file_url" type="video/mp4" />
                                    Your browser does not support the video tag.
                                  </video>
                                </div>

                                <!-- 🧾 Word, Excel, TXT, Others -->
                                <div v-else class="file-placeholder-case ">
                                  <i class="fas fa-file-alt"></i>
                                  <a :href="file.file_url" target="_blank" class="file-link">
                                    {{ getFileName(file?.file?.name || file.file_url) }}
                                  </a>
                                </div>

                                <!-- ❌ Remove File -->
                                <button type="button" v-if="user?.roles[0] !== 'super_admin'"
                                  @click="removeFileCase(index, file.id)" class="remove-btn">×</button>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                      <!-- <div class="submit-button text-end">
                        <button type="button" class="btn btn-light" @click="handleCancel">
                          Back
                        </button>
                        <button type="submit" class="btn btn-primary">Update</button>
                      </div> -->
                    </Form>
                  </div>
                </div>
              </div>
            </div>

            <!-- Comment Stream Card -->
            <div class="card p-3">
              <label for="streamTextarea" class="form-label">Comments</label>
              <textarea v-model="comment" id="streamTextarea" class="form-control mb-2" rows="3"
                placeholder="Type your comment..."></textarea>

              <div class="d-flex align-items-center gap-2 mb-3" v-if="comment">
                <button class="btn btn-primary btn-sm" @click="postComment">Post</button>
                <!-- Upload Icon -->
                <div class="upload-icon">
                  <button type="button" class="btn d-flex align-items-center gap-2" @click="triggerFileInput"
                    style="background-color: #f1f1f1; color: #6c757d; border: none; padding: 6px 12px; border-radius: 6px;">
                    <i class="ti ti-paperclip" style="font-size: 18px;"></i>
                    <!-- Attachments -->
                  </button>
                </div>

                <!-- Hidden File Input -->
                <input type="file" ref="fileInput" @change="handleFileUpload" multiple style="display: none;" />

                <!-- Image Previews -->
                <!-- <div v-for="(img, index) in previewImages" :key="index" class="attachment-preview-reply">
                  <img :src="img.file_url" alt="attachment" />
                  <button type="button" @click="removeImage(index, img.id)" class="remove-btn">×</button>
                </div> -->
                <div class="file-container">
                  <div v-for="(file, index) in previewFiles" :key="index" class="attachment-preview-reply">
                    <!-- 📷 Image Preview -->
                    <div v-if="isImage(file?.file?.name || file.file_url)" class="file-placeholder ">
                      <a :href="file.file_url" target="_blank">
                        <img :src="file.file_url" alt="Image Preview" style="cursor: pointer;" />
                      </a>
                    </div>

                    <!-- 📄 PDF Preview -->
                    <!-- <div v-else-if="isPDF(file.file.name)">
                              <iframe :src="file.file_url" type="application/pdf" width="100%" height="300"></iframe>
                            </div> -->

                    <!-- 🎧 Audio Preview -->
                    <div v-else-if="isAudio(file?.file?.name || file.file_url)" class="file-placeholder ">
                      <audio controls :src="file.file_url"></audio>
                    </div>

                    <!-- 🎞 Video Preview -->
                    <div v-else-if="isVideo(file?.file?.name || file.file_url)" class="file-placeholder ">
                      <video controls width="100%">
                        <source :src="file.file_url" type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    </div>

                    <!-- 🧾 Word, Excel, TXT, Others -->
                    <div v-else class="file-placeholder">
                      <!-- <i class="fas fa-file-alt"></i> -->
                      <a :href="file.file_url" target="_blank" class="file-link">
                        {{ getFileName(file?.file?.name || file.file_url) }}
                      </a>
                    </div>

                    <!-- ❌ Remove File -->
                    <button type="button" @click="removeImage(index, file.id)" class="remove-btn">×</button>
                  </div>
                </div>
              </div>

              <div class="comment-section border-top pt-3" v-for="(reply, index) in form.replies" :key="reply.id">
                <div class="mb-3">
                  <div class="fw-bold">
                    {{ reply.user?.first_name }} {{ reply.user?.last_name }}
                    <!-- <span class="text-muted small">posted</span> -->
                  </div>
                  <p class="mb-1">{{ reply.message }}</p>

                  <!-- Files Previews -->
                  <!-- <div class="d-flex align-items-center gap-2 mb-3">
                    <div v-for="(img, i) in reply.attachments" :key="i" class="attachment-preview-reply">
                      <img :src="img.file_url" alt="attachment" /
                    </div>
                  </div> -->

                  <div class="file-container">
                    <div v-for="(file, index) in reply.attachments" :key="index" class="attachment-preview-reply">
                      <!-- 📷 Image Preview -->
                      <div v-if="isImage(file?.file?.name || file.file_url)" class="file-placeholder ">
                        <a :href="file.file_url" target="_blank">
                          <img :src="file.file_url" alt="Image Preview" style="cursor: pointer;" />
                        </a>
                      </div>

                      <!-- 📄 PDF Preview -->
                      <!-- <div v-else-if="isPDF(file.file.name)">
                              <iframe :src="file.file_url" type="application/pdf" width="100%" height="300"></iframe>
                            </div> -->

                      <!-- 🎧 Audio Preview -->
                      <div v-else-if="isAudio(file?.file?.name || file.file_url)" class="file-placeholder ">
                        <audio controls :src="file.file_url"></audio>
                      </div>

                      <!-- 🎞 Video Preview -->
                      <div v-else-if="isVideo(file?.file?.name || file.file_url)" class="file-placeholder ">
                        <video controls width="100%">
                          <source :src="file.file_url" type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>

                      <!-- 🧾 Word, Excel, TXT, Others -->
                      <div v-else class="file-placeholder">
                        <i class="fas fa-file-alt"></i>
                        <a :href="file.file_url" target="_blank" class="file-link">
                          {{ getFileName(file?.file?.name || file.file_url) }}
                        </a>
                      </div>

                      <!-- ❌ Remove File -->
                      <!-- <button type="button" @click="removeImage(index, file.id)" class="remove-btn">×</button> -->
                    </div>
                  </div>

                  <div class="text-muted small mt-1">
                    {{ new Date(reply.created_at).toLocaleString() }}
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" v-else-if="showFallback">
    <div class="col-md-12">
      <no-data-found />
    </div>
</div>
</template>

<script>
import {
  ref,
  watch,
  onMounted,
  computed,
} from "vue";
import {
  mapGetters,
  useStore
} from "vuex";
import {
  useRoute,
  useRouter
} from 'vue-router';
import Multiselect from 'vue-multiselect';

import {
  Form,
  Field,
  ErrorMessage,
  useForm
} from "vee-validate";
import * as Yup from "yup";
import { changeFormate } from '../../../../util'
import { message } from "ant-design-vue";
import moment from "moment";
export default {
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect
  },
  data() {
    return {
      dateFormat: "dd/MM/yyyy",
      title: "Case",
    };
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const Options = computed(() => store.getters['suppportCases/getcasesDropdowns']);
    const user = computed(() => store.getters['auth/user']);

    const fileInput = ref(null)
    const fileInputCase = ref(null)
    const previewImages = ref([])
    const previewFiles = ref([])
    const createDate = ref()
    const showFallback = ref(false)
    const caseData = ref({})

    const triggerFileInput = () => {
      fileInput.value.click()
    }

    const triggerFileInputCase = () => {
      fileInputCase.value.click()
    }

    const handleFileUpload = (event) => {
      const files = Array.from(event.target.files)
      files.forEach((file) => {
        const file_url = URL.createObjectURL(file)
        previewFiles.value.push({ file, file_url, id: '' })
      })
      // reset input so same file can be uploaded again if needed
      fileInput.value.value = ''
    }

    const handleFileUploadCase = async (event) => {
      const files = Array.from(event.target.files)
      const images = []
      const formData = new FormData()
      files.forEach((file) => {
        const file_url = URL.createObjectURL(file)
        images.push({ file, file_url, id: '' })
      })

      images.forEach((imgObj) => {
        if (imgObj.file) {
          formData.append('documents[]', imgObj.file)
        }
      })

      const caseId = route.query.caseId
      const response = await store.dispatch('suppportCases/uploadDocument', { caseId, formData })
      if (response?.status) {
        fileInput.value = ''
        message.success(response.message)
        await fetchCases(caseId)
      }
    }

    const removeImage = async (index, id) => {
      previewFiles.value.splice(index, 1)
      if (id) {
        const response = await store.dispatch('suppportCases/deleteDocument', id)
        if (response.status) {
          message.success(response.message)
        }
      }
    }

    const removeFileCase = async (index, id) => {
      previewImages.value.splice(index, 1)
      if (id) {
        const response = await store.dispatch('suppportCases/deleteDocument', id)
        if (response.status) {
          message.success(response.message)
        }
      }
    }

    const schema = Yup.object().shape({
      subject: Yup.string()
        .required("Name is required"),
    });

    const form = ref({
      id: '',
      subject: '',
      status: null,
      priority: null,
      type: null,
      description: '',
    });


    const updateCase = async () => {
      try {

        const keysToExtract = ['id', 'subject', 'status', 'priority', 'type', 'description'];

        if (form.value.id) {
          const plainForm = Object.fromEntries(
            keysToExtract.map((key) => [key, form.value[key]])
          );
          form.value = { ...plainForm }
        }

        const formData = new FormData()

        // Append form fields
        for (const key in form.value) {
          if (form.value[key] !== null && form.value[key] !== undefined) {
            formData.append(key, form.value[key])
          }
        }
        // Append uploaded images
        previewImages.value.forEach((imgObj) => {
          if (imgObj.file) {
            formData.append('documents[]', imgObj.file)
          }
        })

        // Dispatch with FormData
        let data;
        if(user.value?.roles[0] === 'super_admin'){
          data = await store.dispatch('suppportCases/updateAdminCase', {
          id: form.value.id,
          formData
        })
      } else{
        data = await store.dispatch('suppportCases/updateCase', {
          id: form.value.id,
          formData
        })
      }

        if (data.status) {
          message.success(data.message)
          handleCancel()
        }
      } catch (error) {
        console.error('Error creating case:', error)
      }
    }

    const postComment = async () => {
      try {
        const formData = new FormData()
        formData.append('message', comment.value)

        // Append uploaded images
        previewFiles.value.forEach((imgObj) => {
          if (imgObj.file) {
            formData.append('documents[]', imgObj.file)
          }
        })

        const response = await store.dispatch('suppportCases/addComment', {
          formData,
          id: form.value.id,
        })

        if (response?.status) {
          previewFiles.value = []
          comment.value = ''
          fetchCases(form.value.id)
        }
      } catch (error) {
        console.error('Error creating case:', error)
      }
    }

    const fetchCases = async (id) => {
      let response;
      if(user.value?.roles[0] === 'super_admin'){
        response = await store.dispatch('suppportCases/fetchAdminCase', id);
      } else{
        response = await store.dispatch('suppportCases/fetchCase', id);
      }
      if(!response){
                    showFallback.value = true;
                    return
                }
      if (response?.status) {
        caseData.value = response.data || {}
        Object.assign(form.value, response.data)
        createDate.value = moment(form.value.created_at).format('YYYY-MM-DD HH:mm:ss')
        previewImages.value = response.data.attachments;
      }
    }

    const isImage = (fileUrl) => {
      return /\.(jpg|jpeg|png|gif|webp|svg)$/i.test(fileUrl);
    }
    const isPDF = (fileUrl) => {
      return /\.pdf$/i.test(fileUrl);
    }
    const isAudio = (fileUrl) => {
      return /\.(mp3|wav|ogg)$/i.test(fileUrl);
    }
    const isVideo = (fileUrl) => {
      return /\.(mp4|webm|ogg)$/i.test(fileUrl);
    }
    const getFileName = (fileUrl) => {
      return fileUrl.split('/').pop();
    }


    const handleCancel = () => {
      if (user.value?.roles[0] === 'super_admin') {
        router.push({
          path: "/crm/support-list",
        });
      } else {
        router.push({
          path: "/crm/support-case-list",
        });
      }

    }

    const comment = ref('');

    onMounted(async () => {
      await store.dispatch('suppportCases/fetchcasesOptions');
      const caseId = route.query.caseId
      if (caseId) {
        fetchCases(caseId)
      }
    });
    return {
      store,
      route,
      router,
      schema,
      Options,
      form,
      updateCase,
      handleCancel,
      fileInput,
      previewImages,
      previewFiles,
      removeImage,
      handleFileUpload,
      triggerFileInput,
      fetchCases,
      triggerFileInputCase,
      comment,
      postComment,
      user,
      createDate,
      isImage,
      isPDF,
      isAudio,
      isVideo,
      getFileName,
      handleFileUploadCase,
      removeFileCase,
      fileInputCase,
      caseData,
      showFallback

    };
  },
};
</script>

<style scoped>
textarea {
  resize: none;
}

.attachment-preview,
.attachment-preview-reply {
  display: flex;
  align-items: center;
  background: #f2f2f2;
  border-radius: 6px;
  margin-bottom: 10px;
  overflow: hidden;
  position: relative;
  max-width: 150px;
}

.attachment-preview img {
  width: 150px;
  height: 70px;
  object-fit: cover;
  border-right: 1px solid #ccc;
}

.attachment-preview-reply {
  /* overflow-x: auto; */
  height: 90px;
  max-width: 200px;
}

.attachment-preview-reply img {
  max-width: 150px;
}

img {
  transition: 0.2s;
}

img:hover {
  opacity: 0.8;
}

.upload-icon {
  display: inline-block;
  margin-top: 5px;
  margin-bottom: 10px;
}

.remove-btn {
  background: transparent;
  border: none;
  color: #000;
  font-size: 20px;
  margin-left: auto;
  padding: 0 12px;
  cursor: pointer;
}

img,
iframe,
video {
  max-width: 100%;
  border-radius: 6px;
}

audio,
video {
  margin-top: 10px;
}

.file-placeholder {
  width: 100%;
  /* border: 1px dashed #ccc; */
  padding: 12px;
  text-align: center;
  border-radius: 5px;
}

.file-placeholder-case {
  /* width: 100%; */
  width: 84%;
  /* border: 1px dashed #ccc; */
  padding: 12px;
  text-align: center;
  border-radius: 5px;
}

.file-link {
  color: #007bff;
  text-decoration: none;
  transition: color 0.2s;
  cursor: pointer;
}

.file-link:hover {
  color: #0056b3;
  text-decoration: underline;
}

.file-container {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.readonly-field {
  background-color: #e9ecef;
  cursor: not-allowed;
}
</style>